import React from "react";
import { TextField, TextFieldProps } from "@mui/material";

import { formatCNPJOrCPF } from "@utils/fiscal/helper";
import { unmaskCnpj } from "@utils/fiscal/cnpj/cnpj.helpers";

type CnpjCpfFieldProps = Omit<TextFieldProps, "onChange" | "value"> & {
  value: string;
  onChange: (raw: string, formatted: string) => void;
  maxLength?: number;
};

const CnpjCpfField: React.FC<CnpjCpfFieldProps> = ({
  value,
  onChange,
  maxLength = 14,
  ...props
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = unmaskCnpj(e.target.value);
    if (raw.length <= maxLength) {
      onChange(raw, formatCNPJOrCPF(raw));
    }
  };

  return (
    <TextField
      {...props}
      variant="outlined"
      value={formatCNPJOrCPF(value)}
      onChange={handleChange}
      inputProps={{ maxLength: 18, ...props.inputProps }}
      sx={{
        ...props.sx,
        "& label": { color: "text.primary" },
      }}
      fullWidth
    />
  );
};

export default CnpjCpfField;
